import React, {useEffect} from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function SchoolTiming() {
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
  }, []);
  return (
    <>
      <section className="bg-gradient-to-r from-red-600 to-[#ff4e1c] py-24 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-wide" data-aos="fade-down">
            School Timing
          </h1>
          <p className="mt-3 text-green-100 text-base md:text-lg" data-aos="fade-up" data-aos-delay="150">
            Punctuality: Your Pathway to Academic Excellence
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 py-16">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-normal text-gray-900" data-aos="fade-up">
            <span>Krishna Public School</span> Timing
          </h2>
          <div className="w-24 h-1 bg-[#ff4e1c] mx-auto mt-4 rounded-full" data-aos="zoom-in" data-aos-delay="150"></div>
        </div>

        <div className="overflow-x-auto" data-aos="fade-up" data-aos-delay="250">
          <div className="grid grid-cols-3 min-w-[700px] rounded-xl overflow-hidden shadow-lg">

            <div className="bg-gradient-to-r from-red-600 to-[#ff4e1c] text-white font-semibold p-4 text-center" data-aos="fade-down">
              Class
            </div>
            <div className="bg-red-100 text-gray-900 font-semibold p-4 text-center" data-aos="fade-down" data-aos-delay="100">
              Summer Timings
            </div>
            <div className="bg-red-100 text-gray-900 font-semibold p-4 text-center" data-aos="fade-down" data-aos-delay="200">
              Winter Timings
            </div>

            <div className="bg-gradient-to-r from-red-600 to-[#ff4e1c] text-white p-4 font-medium text-center" data-aos="fade-up" data-aos-delay="250">
              Junior (PRE-NUR. – K.G.)
            </div>
            <div className="bg-gray-50 p-4 text-center text-gray-700" data-aos="fade-up" data-aos-delay="300">
              8:00 AM – 12:00 PM
            </div>
            <div className="bg-gray-50 p-4 text-center text-gray-700" data-aos="fade-up" data-aos-delay="350">
              9:10 AM – 1:00 PM
            </div>
            <div className="bg-gradient-to-r from-red-600 to-[#ff4e1c] text-white p-4 font-medium text-center" data-aos="fade-up" data-aos-delay="250">
              Senior (Ist. – VII.)
            </div>
            <div className="bg-gray-50 p-4 text-center text-gray-700" data-aos="fade-up" data-aos-delay="300">
              8:00 AM – 12:00 PM
            </div>
            <div className="bg-gray-50 p-4 text-center text-gray-700" data-aos="fade-up" data-aos-delay="350">
              9:10 AM – 1:00 PM
            </div>

          </div>
        </div>
      </section> 
    </>
  );
}
